export const truthData = [
    {
        id: 1,
        text: 'Breathing in, I send myself love. Breathing out, I send love to someone else who needs it.'
    },
    {
        id: 2,
        text: 'Don\'t let yesterday take up too much of today.'
    },
    {
        id: 3,
        text: 'Every day is a second chance.'
    },
    {
        id: 4,
        text: 'Tell the truth and love everyone.'
    },
    {
        id: 5,
        text: 'I am free from sadness.'
    },
    {
        id: 6,
        text: 'I am enough.'
    },
    {
        id: 7,
        text: 'In the beginning it is you, in the middle it is you and in the end it is you.'
    },
    {
        id: 8,
        text: 'I love myself.'
    },
    {
        id: 9,
        text: 'I am present now.'
    },
    {
        id: 10,
        text: 'Inhale the future, exhale the past.'
    },
    {
        id: 11,
        text: 'This too shall pass.'
    },
    {
        id: 12,
        text: 'Yesterday is not today.'
    },
    {
        id: 13,
        text: 'The only constant is change.'
    },
    {
        id: 14,
        text: 'Onward and upward.'
    },
    {
        id: 15,
        text: 'I am the sky, the rest is weather.'
    }
]